// extracted by mini-css-extract-plugin
export default {"saveCountWrapper":"ii5iT","saveCountvalue":"BFMOG","saveCountHeartIcon":"Qg1xL"};